import React, { Component } from 'react'
import { API_URL } from '../../constants';
import { getAccessToken, getCookie } from '../../helpers/cookieHelper';
import { Panel, Messager, Button, LinkButton, TextBox ,FormField,Form,Dialog} from 'rc-easyui'

const axios = require("axios");


export default class ModulesDetail extends Component {

    constructor(props) {
        super(props)

        this.state = {
            isLoading: false,
            id:null,
            modulesDetail:null,
            data: null,
            operation:'save',
            closed:true
        }
    }






    componentDidMount = async () => {
        this.getData()
    }


    getData = async () => {
        let erp_access_token = getCookie('access_token')
        let erp_token_type = getCookie('token_type')
        let headerConfig = {
            headers: {
                authorization: erp_token_type + ' ' + erp_access_token,
                'Content-Type': 'application/json',
            },
        }
        //   console.log(erp_access_token)
        if (erp_access_token != null) {
            this.setState({
                isLoading: true,
            })
            // let url = API_URL + 'api/fetchallprojectInfo';
            let url = `${API_URL}api/getmoduledetail`
            await axios.get(url, headerConfig)
                .then((response) => {
                    this.setState({ isLoading: false })
                    if (response.status === 200) {
                        var dataObject = response.data.object
                        var id=response.data.object.id
                        console.log(dataObject);
                        this.setState({
                            data: dataObject,
                            modulesDetail:dataObject.modulesDetail,
                            id:id
                        })

                    } else {
                        this.setState({
                            data: '',
                        })
                    }
                })
                .catch((error) => {
                    this.setState({
                        data: '',
                        isLoading: false
                    })
                    // alert ("Internal server error");
                    let response = error['response']
                    if (response !== undefined) {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            reload: false,
                            msg: response.data.message
                        })//Backend Validation Error i.e. 403
                    } else {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            msg: 'Internal Server Error',
                            reload: false,
                        })// Caused due to syntax error in front end
                    }
                })


        } else {
            const resp = await getAccessToken()
            if (resp) {
                this.getData()
            }
        }

    }

    handleChange=(value)=>{
          this.setState({modulesDetail:value})
    }

    handleUpdate = async () => {
        let erp_access_token = getCookie('access_token')
        let erp_token_type = getCookie('token_type')
        let headerConfig = {
            headers: {
                authorization: erp_token_type + ' ' + erp_access_token,
                'Content-Type': 'application/json',
            },
        }
        let data={
            id:this.state.id,
            modulesDetail:this.state.modulesDetail
        }

        if (erp_access_token != null) {
            this.setState({
                isLoading: true,
                closed:true
            })
            let url = `${API_URL}api/updatemoduledetails`
            axios
                .put(url,data,headerConfig)
                .then((response) => {
                    if (response.status === 200) {
                        this.setState({
                            isLoading: false,
                        });
                        if (response.data.status) {
                            this.messager.alert({
                                title: "Success",
                                msg: response.data.message,
                                reload: true,
                            }); // User  Updated Successfully ie. 200
                        } else {
                            this.messager.alert({
                                title: "Error",
                                msg: response.data.message,
                            });
                        }
                    } else {
                        this.messager.alert({
                            title: "Error",
                            msg: "Uncaught Error",
                            reload: false,
                        });
                    }
                })
                .catch((error) => {
                    this.setState({
                        isLoading: false,
                    });
                    this.messager.alert({
                        title: "Error",
                        msg: "Internal Server Error",
                        reload: false,
                    });
                    var response = error["response"];
                    if (response !== undefined) {
                        if (response.status === 400) {
                            var message = "";
                            response.data.errors.forEach((row, i) => {
                                message +=
                                    "<p style='margin-bottom:3px;'>" +
                                    row.defaultMessage +
                                    "</p>";
                            });
                            this.messager.alert({
                                title: "Error",
                                msg: message,
                                reload: false,
                            }); // Backend Validation Error ie.400
                        } else {
                            this.messager.alert({
                                title: "Error",
                                msg: "UnCaught Error",
                                reload: false,
                            }); // Uncaught Backend Error ie.500 eyc.
                        }
                    } else {
                        this.messager.alert({
                            title: "Error",
                            msg: "Internal Server Error",
                            reload: false,
                        }); // Caused due to syntax error in front end
                    }
                });
        } else {
            //Access Token Expired.
            //Generate new Access Token using Refresh Token.
            const resp = await getAccessToken();
            if (resp) {
                this.handleUpdate();
            }
        }

    }

    handleEdit=()=>{
        this.setState({
            operation:'update'
        })
       
    }

    renderDialog() {
        const row = this.state.model;
        const { title, closed, rules } = this.state;
        return (
          <Dialog modal title={title} closed={closed} onClose={() => this.setState({ closed: true, btn: null })}>
            <div className="f-full" style={{ padding: '20px 50px' }}>
              <Form className="f-full"
              >
                <div style={{ marginBottom: 10 }}>
                  <h6>Are you sure you want to update module details?
                    </h6>
                
                  
                  {/* <div className="error">{this.getError('comments')}</div> */}
                </div>
              </Form>
            </div>
            <div className="dialog-button">
              <LinkButton className="btn btn-primary" style={{ width: "80px", height: "35px", padding: "2px" }} onClick={() => this.handleUpdate()}>Yes</LinkButton>
              <LinkButton className="btn btn-danger" style={{ width: "80px", height: "35px", padding: "2px" }} onClick={() => this.setState({ closed: true })}>No</LinkButton>
            </div>
          </Dialog>
        )
      }


    render() {
        const { permissions } = this.props;

        const isLoading = this.state.isLoading;

        const styles = { width: 110, height: 30 };

        return (
            <div>

                <Panel
                    title='Modules Detail'
                    bodyStyle={{ padding: 0 }}
                    style={{ height: 500 }}>
                    <Messager
                        ref={(ref) => (this.messager = ref)}
                        showHeader={false}
                        borderType='none'
                        content={({ title, msg, buttons, reload }) => (
                            <div className='alert-content'>
                                <h3>{title}</h3>
                                <div
                                    style={{ marginBottom: 5 }}
                                    dangerouslySetInnerHTML={{ __html: msg }}
                                ></div>
                                <div className='m-buttons'>
                                    {buttons.map((button, index) => (
                                        <LinkButton
                                            key={index}
                                            text={button.text}
                                            onClick={() => {
                                                this.messager.close(button);
                                                if (reload) {
                                                    window.location.reload();
                                                }
                                            }}
                                        />
                                    ))}
                                </div>
                            </div>
                        )}
                    />
                    <div
                        className='loadingmodel'
                        style={{ display: isLoading ? "block" : "none" }}
                    ></div>
                    
                    
                        <TextBox
                            value={this.state.modulesDetail}
                            style={{ width: '800px', height: '400px', marginLeft: '200px', marginTop: '10px' }}
                            multiline
                            editable={this.state.operation==='save' ? false:true}
                            onChange={this.handleChange}
                        >
                        </TextBox>
                    
                    
                    <div style={{ marginLeft: "500px", marginTop: '10px' }}>
                        {this.state.operation==='save'?<LinkButton className= 'btn btn-primary' onClick={this.handleEdit}>Edit</LinkButton>:''}
                        {this.state.operation==='update'? <LinkButton className='btn btn-secondary' onClick={()=>this.setState({closed:false})}>Update</LinkButton>:''}
                    </div>
                    {this.renderDialog()}
                </Panel>




            </div>
        )
    }
}
